<template>
  <br />
  <div class="mx-auto max-w-7xl px-6 xl:px-0 my-20 md:my-28">
    <div class="lg:flex xl:gap-6 xl:space-y-0">
      <div
        class="lg:w-3/5 mb-8"
        v-motion
        :initial="{ opacity: 0, y: 100 }"
        :visible-once="{
          opacity: 1,
          y: 0,
          scale: 1,
          transition: {
            delay: 200,
            duration: 800,
            opacity: {
              duration: 800
            }
          }
        }"
      >
        <div class="lg:flex lg:flex-col lg:items-start">
          <h2
            class="text-gray-800 text-3xl xl:text-5xl xl:px-0 xl:max-w-5xl font-semibold text-center lg:text-start"
          >
            Contacte con nosotros
          </h2>
          <p class="mt-5 text-gray-800 text-center lg:text-start text-lg">
            ¿Listo para dar el siguiente paso hacia la transformación digital?
          </p>
          <p class="mt-3 text-gray-600 text-center lg:text-start text-base pb-6 border-b">
            No dude en escribirnos o llamarnos para agendar una demostración personalizada y obtener
            más información sobre nuestras soluciones. Estamos aquí para responder cualquier
            pregunta que pueda tener y ayudarle a encontrar la mejor opción para su empresa.
          </p>

          <div class="flex flex-col lg:flex-row lg:justify-between w-full">
            <a
              href="https://wa.me/593978633036?text=Deseo%20conocer%20más%20sobre%20su%20producto%20y%20obtener%20una%20demo"
            >
              <p class="mt-8 text-gray-800 text-center lg:mr-2 lg:text-start text-base">
                <span class="font-bold"> Llamadas y Whatsapp </span>
                <span class="block mt-1 text-center lg:text-start text-sm">
                  (+593) 97 863 3036
                </span>
              </p>
            </a>

            <p class="mt-8 text-gray-800 text-center lg:mr-4 lg:text-start text-base">
              <span class="font-bold"> Envíanos un correo </span>
              <a
                class="text-blue-600 mt-1 text-center lg:text-start hover:cursor-pointer hover:underline"
                href="mailto:gerencia.softdevel@gmail.com"
              >
                <span class="block mt-1 text-center lg:text-start text-sm">
                  gerencia.softdevel@gmail.com
                </span>
              </a>
            </p>

            <p class="mt-8 text-gray-800 text-center lg:text-start text-base">
              <span class="font-bold"> Visítanos </span>

              <span class="block mt-1 text-center lg:text-start text-sm">
                Diego de Almagro y República.
                <br />
                Edificio MS. Oficina 401.
              </span>
            </p>
          </div>
        </div>

        <div class="mt-8 border-8 border-gray-50 rounded-2xl">
          <iframe
            class="rounded-lg"
            width="100%"
            height="300"
            frameborder="0"
            style="border: 0"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3989.795124195482!2d-78.48665092404757!3d-0.1953750998026838!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x91d59a71a5d6225d%3A0x18ef00f4655f7727!2sDiego%20de%20Almagro%20Y%20de%20la%20Republica!5e0!3m2!1ses-419!2sec!4v1712609326149!5m2!1ses-419!2sec"
            loading="lazy"
          ></iframe>
        </div>
      </div>

      <div class="items-center lg:w-2/5 lg:pl-10">
        <div class="bg-white shadow-2xl rounded-2xl px-8 py-6 border-2 border-gray-50">
          <div>
            <label for="name-input" class="block text-sm font-semibold leading-6 text-gray-900">
              Nombre Completo
              <span class="error-validation">*</span>
            </label>
            <div class="mt-2">
              <input
                v-model="name"
                @input="validateName"
                class="block w-full rounded-md border-0 p-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-indigo-600 text-base sm:leading-6"
                type="text"
                placeholder="Nombre completo"
                id="name-input"
              />
              <span class="error-validation" :class="nameIsValid ? 'invisible' : 'visible'">
                El nombre es requerido
              </span>
            </div>
          </div>

          <div>
            <label
              for="company-input"
              class="block text-sm font-semibold leading-6 text-gray-900 pt-1"
            >
              Empresa
              <span class="text-gray-400">(opcional)</span>
            </label>
            <div class="mt-2">
              <input
                v-model="company"
                @input="validateCompany"
                class="block w-full rounded-md border-0 p-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-indigo-600 text-base sm:leading-6"
                type="text"
                placeholder="Nombre Empresa"
                id="company-input"
              />
              <span class="error-validation" :class="companyIsValid ? 'invisible' : 'visible'">
                El nombre de la empresa es requerido
              </span>
            </div>
          </div>

          <div>
            <label
              for="phone-input"
              class="block text-sm font-semibold leading-6 text-gray-900 pt-1"
            >
              Número Télefono
              <span class="error-validation">*</span>
            </label>
            <div class="mt-2">
              <input
                v-model="phone"
                @input="validatePhone"
                class="block w-full rounded-md border-0 p-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-indigo-600 text-base sm:leading-6"
                type="text"
                placeholder="Número Télefono"
                id="phone-input"
              />
              <span class="error-validation" :class="phoneIsValid ? 'invisible' : 'visible'">
                {{
                  phone.trim() === ''
                    ? 'El número de télefono es requerido'
                    : 'Formato de número incorrecto'
                }}
              </span>
            </div>
          </div>

          <div>
            <label for="email" class="block text-sm font-semibold leading-6 text-gray-900 pt-1">
              Correo
              <span class="error-validation">*</span>
            </label>
            <div class="mt-2">
              <input
                v-model="email"
                @input="validateEmail"
                class="block w-full rounded-md border-0 p-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-indigo-600 text-base sm:leading-6"
                type="text"
                placeholder="Correo"
              />
              <span class="error-validation" :class="emailIsValid ? 'invisible' : 'visible'">
                Ingrese un correo electrónico válido
              </span>
            </div>
          </div>

          <div>
            <label for="message" class="block text-sm font-semibold leading-6 text-gray-900 pt-2">
              Envíanos un mensaje
              <span class="error-validation">*</span>
            </label>
            <div class="mt-2">
              <textarea
                v-model="message"
                @input="validateMessage"
                rows="4"
                name="message"
                id="message-input"
                placeholder="Escriba aquí su mensaje"
                class="block w-full h-24 rounded-md border-0 p-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-indigo-600 text-base sm:leading-6"
              />
              <span class="error-validation" :class="messageIsValid ? 'invisible' : 'visible'">
                El mensaje es requerido
              </span>
            </div>

            <div class="mt-2">
              <button
                type="submit"
                @click="submitForm"
                class="w-full items-center h-10 border border-transparent rounded-lg text-white bg-black flex justify-center hover:bg-black/80"
              >
                <span class="font-semibold lg:block"> Enviar Mensaje </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="absolute top-96 left-0 w-full h-full grid grid-cols-2 -space-x-52"
    style="margin-top: -10rem; z-index: -1"
  >
    <div class="h-96 bg-gradient-to-br from-white to-white blur-[50px]"></div>
    <div class="h-96 bg-gradient-to-br from-purple-200 to-primary blur-[50px]"></div>
  </div>

  <footer-navigation />
</template>
<script setup lang="ts">
import FooterNavigation from '@/components/FooterNavigation.vue';
import { ref } from 'vue';

const name = ref('');
const company = ref('');
const phone = ref('');
const message = ref('');
const email = ref('');

const nameIsValid = ref(true);
const companyIsValid = ref(true);
const phoneIsValid = ref(true);
const messageIsValid = ref(true);
const emailIsValid = ref(true);

function validateName() {
  nameIsValid.value = name.value.trim() !== '';
}

function validateCompany() {
  companyIsValid.value = company.value.trim() !== '';
}

function validatePhone() {
  const regex = /^\+?[0-9]+$/;

  if (phone.value.trim() === '') {
    phoneIsValid.value = false;
  } else {
    phoneIsValid.value = regex.test(phone.value.trim());
  }
}

function validateMessage() {
  messageIsValid.value = message.value.trim() !== '';
}

function validateEmail() {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  emailIsValid.value = emailRegex.test(email.value);
}

function submitForm() {
  validateName();
  validateCompany();
  validatePhone();
  validateEmail();
  validateMessage();
}
</script>

<style>
.error-validation {
  color: red;
  font-size: 12px;
}
</style>
